<template>
  <AffirmBanner
    v-if="paymentMethod"
    :base-price
    class="mb-12"
    :payment-method
  />

  <DefaultRedirectionText v-if="paymentGroup" :group="paymentGroup" />

  <slot />
</template>

<script setup lang="ts">
import AffirmBanner from '../../../../advertising/components/AffirmBanner/AffirmBanner.vue'
import type { PaymentFormAdornmentProps } from '../PaymentFormAdornment.type'

import DefaultRedirectionText from './DefaultRedirectionText.vue'

defineProps<PaymentFormAdornmentProps>()
</script>
